rs.module("fund/configuration/insuranceratetiers/tiertypes",

    [
        "controls/components/event-banner",
        "common/select-helper",
        "common/visibility"
    ],

    function (eventBanner, selectHelper, visibility) {

        var _executeSelectionChanged;
        var _criteria;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, grid) {
            _criteria = $.js(jsSelectors.criteria);
            var insuranceRateTierTypeAddButton = _criteria.js(jsSelectors.insuranceRateTierTypeAddButton);
            var insuranceRateTierTypeCancelButton = _criteria.js(jsSelectors.insuranceRateTierTypeCancelButton);
            var insuranceRateTierTypeKey = _criteria.js(jsSelectors.insuranceRateTierTypeKey);
            var insuranceRateTierInsuranceType = _criteria.js(jsSelectors.insuranceRateTierInsuranceType);

            //Select helpers
            var insuranceTypeSelectHelper = selectHelper.getHelper(insuranceRateTierInsuranceType);

            // On grid selection change, we will update the detail history form data.
            grid.selectionChanged(function (values, rows) {
                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    // Retrieve new form data
                    $.get(
                        backendUrls.loadRateTierType,

                        { insuranceRateTierTypeKey: values[0] })

                        .done(function (data) {

                            insuranceRateTierTypeKey.val(data.insuranceRateTierTypeKey);
                            insuranceTypeSelectHelper.setValue(data.insuranceType);
                        });

                    clearBanner();
                }

                _executeSelectionChanged = true;
            });

            // Clear values to get ready to add a new Insurance Type to a Rate Tier
            insuranceRateTierTypeAddButton.click(function () {
                clearBanner();
                grid.selectedValues = null;
                insuranceRateTierTypeKey.val(-1);
                insuranceTypeSelectHelper.setValue(null);
            });

            // On the cancel link button click, reset the form
            insuranceRateTierTypeCancelButton.click(function () {
                grid.selectedValues = null;
                grid.selectFirstRow();
                clearBanner();
            });

            // Clear the event banner of all messages.
            function clearBanner() {
                eventBanner.removeErrorMessages();
                eventBanner.removeInformationalMessages();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }

)